import React, { useState } from 'react';
import './Contact.css';
import { Request } from '../context/Request';


const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');
    setSubmitting(true);
    try {
      // Basic front-end validation
      if (!formData.name || !formData.email || !formData.subject || !formData.message) {
        throw new Error('Please fill out all fields.');
      }

      const payload = await Request('/contact', 'POST', formData);

      if (payload && (payload.success || payload.status === 'ok')) {
        setSuccessMessage('Thank you! Your message has been sent.');
      } else {
        // If backend returns something else, still show a generic success if no explicit error occurred
        setSuccessMessage('Thank you! Your message has been sent.');
      }

      // Reset the form after successful submit tttt
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      setErrorMessage(err?.message || 'Sorry, something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-header">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you</p>
      </div>

      <div className="contact-container">
        <div className="contact-info">
          <div className="info-section">
            <h3>Customer Service</h3>
            <p>Monday - Friday: 9am - 5pm EST</p>
            <p>Email: epoxygardencom@gmail.com</p>
            <p>Phone: (945) 301-3066</p>
          </div>

          <div className="info-section">
            <h3>Our Location</h3>
            <p>2409 Queens ct</p>
            <p>Carrollton, TX 75006</p>
          </div>

          <div className="info-section">
            <h3>Follow Us</h3>
            <div className="social-links">
              <a href="https://instagram.com">Instagram</a>
              <a href="https://facebook.com">Facebook</a>
              <a href="https://pinterest.com">Pinterest</a>
            </div>
          </div>
        </div>

        <div className="contact-form">
          <h2>Send us a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={submitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={submitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="subject">Subject</label>
              <input
                type="text"
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                disabled={submitting}
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="5"
                disabled={submitting}
              ></textarea>
            </div>

            {successMessage && <div className="alert success">{successMessage}</div>}
            {errorMessage && <div className="alert error">{errorMessage}</div>}

            <button type="submit" className="submit-button" disabled={submitting}>
              {submitting ? 'Sending...' : 'Send Message'}
            </button>
          </form>
        </div>
      </div>

      <div className="faq-section">
        <h2>Frequently Asked Questions</h2>
        <div className="faq-grid">
          <div className="faq-item">
            <h3>Shipping Information</h3>
            <p>We offer free shipping on all orders over $100. Standard shipping takes 3-5 business days.</p>
          </div>
          <div className="faq-item">
            <h3>Returns & Exchanges</h3>
            <p>We accept returns within 30 days of purchase. Items must be unworn with original tags attached.</p>
          </div>
          <div className="faq-item">
            <h3>Order Status</h3>
            <p>You can track your order status by logging into your account or using the tracking number provided.</p>
          </div>
          <div className="faq-item">
            <h3>Size Guide</h3>
            <p>Visit our size guide page for detailed measurements and fitting information.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
